import { RegisterApplicationConfig, registerApplication } from "single-spa";
import type { CustomAppConfigs } from "typings";

export function customApplication(
  app: RegisterApplicationConfig,
  customAppConfig: CustomAppConfigs[]
) {
  const customConfig = customAppConfig.find(
    ({ appName }) => appName === app.name
  );
  if (customConfig) {
    app.activeWhen = customConfig.activeWhen;
  }
  return registerApplication(app);
}
